import type { ActivityType } from "@/core/types";

export const activityListKey = {
  base: ["activities"] as const,
  byType: (type: ActivityType) => [...activityListKey.base, type] as const,
};
